<template>
  <div>
    <!-- 跟单备注设置 -->
    <el-dialog :title="$t('message.documentaryRemarksSettings')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="780px" center>
      <div class="content">

        <div class="to">
          <!-- 提示人员 -->
          <el-select v-model="to" multiple placeholder="请选择提示人员" filterable>
            <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <el-input type="textarea" placeholder="请填写备注内容" v-model="remark">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    itemDetail: { type: Object }
  },
  data() {
    return {
      remark: '',
      to: [],
      dialogVisible: false,
      adminList: [],
      name: JSON.parse(localStorage.getItem('japanUserRoleInfo')).role[0].name
    };
  },
  created() {

    // 获取赔款人
    this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
      if (this.name.indexOf('一部') != -1) {
        res.data.data = res.data.data.filter(item => {
          if (item.role != false) {
            if (item.role[0].organization.name.indexOf('一部') != -1) {
              return item
            }
          }
        })
      }
      if (this.name.indexOf('二部') != -1) {
        res.data.data = res.data.data.filter(item => {
          if (item.role != false) {
            if (item.role[0].organization.name.indexOf('二部') != -1) {
              return item
            }
          }
        })
      }
      if (this.name.indexOf('三部') != -1) {
        res.data.data = res.data.data.filter(item => {
          if (item.role != false) {
            if (item.role[0].organization.name.indexOf('三部') != -1) {
              return item
            }
          }
        })
      }
      this.adminList = res.data.data

    })
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.remark = ''
        this.to = []
      }
    }
  },
  methods: {
    // 保存
    save() {
      let datas = {
        list: [{
          order_detail_id: this.itemDetail.id,
          remark: this.remark,
          to: this.to
        }]
      }
      this.$api.orderApi.addOrderDetailNotes(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
      })


    },
  },

};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;

  .to {
    margin-bottom: 20px;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 100%;
  }

  /deep/.el-textarea__inner {
    min-height: 100px !important;
  }
}
</style>